import React, { useEffect, useContext, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { AppSettings } from './../../config/app-settings.js';

function PosCounterCheckout() {
	const context = useContext(AppSettings);
	const [time] = useState(getTime());
	const [tableData, setTableData] = useState();
	const [posMobileSidebarToggled, setPosMobileSidebarToggled] = useState(false);
	const [selectedTable, setSelectedTable] = useState();

	function checkTime(i) {
		if (i < 10) {
			i = '0' + i;
		}
		return i;
	}

	function getTime() {
		var today = new Date();
		var h = today.getHours();
		var m = today.getMinutes();
		var a;
		m = checkTime(m);
		a = h > 11 ? 'pm' : 'am';
		h = h > 12 ? h - 12 : h;

		setTimeout(() => {
			getTime();
		}, 500);
		return h + ':' + m + a;
	}

	function toggleMobileSidebar(event, table) {
		event.preventDefault();

		setPosMobileSidebarToggled(true);
		setSelectedTable(table);
	}

	function dismissMobileSidebar(event) {
		event.preventDefault();

		setPosMobileSidebarToggled(false);
		setSelectedTable([]);
	}

	function getPrice(type) {
		var price = 0;

		if (selectedTable && selectedTable.orders) {
			var orders = selectedTable.orders;
			for (var i = 0; i < orders.length; i++) {
				if (type === 'subtotal') {
					price += parseFloat(orders[i].price);
				} else if (type === 'taxes') {
					price += parseFloat(orders[i].price) * 0.06;
				} else if (type === 'total') {
					price += parseFloat(orders[i].price);
					price += parseFloat(orders[i].price) * 0.06;
				}
			}
		}

		return price.toFixed(2);
	}

	function getTotalPrice(orders) {
		var total = 0;
		if (orders) {
			for (var i = 0; i < orders.length; i++) {
				total += parseFloat(orders[i].price);
			}
		}
		return total.toFixed(2);
	}

	useEffect(() => {
		context.handleSetAppHeaderNone(true);
		context.handleSetAppSidebarNone(true);
		context.handleSetAppClass('app-without-header');
		context.handleSetAppContentFullHeight(true);
		context.handleSetAppContentClass('p-0');

		fetch('/color-admin/admin/react/assets/data/pos/counter-checkout.json')
			.then((res) => res.json())
			.then((result) => {
				setTableData(result);
				setSelectedTable(result[0]);
			});

		return function cleanUp() {
			context.handleSetAppHeaderNone(false);
			context.handleSetAppSidebarNone(false);
			context.handleSetAppClass('');
			context.handleSetAppContentFullHeight(false);
			context.handleSetAppContentClass('');
		};

		// eslint-disable-next-line
	}, []);

	return (
		<div
			className={
				'pos pos-with-header pos-with-sidebar ' + (posMobileSidebarToggled ? 'pos-sidebar-mobile-toggled' : '')
			}
			id="pos"
		>
			<div className="pos-header">
				<div className="logo">
					<Link to="/">
						<div className="logo-img">
							<Icon icon="solar:link-circle-line-duotone" />
						</div>
						<div className="logo-text">Pine & Dine</div>
					</Link>
				</div>
				<div className="time" id="time">
					{time}
				</div>
				<div className="nav">
					<div className="nav-item">
						<Link
							to="/pos/counter-checkout"
							className="nav-link active"
							data-bs-toggle="tooltip"
							data-bs-placement="bottom"
							data-bs-title="Counter Checkout"
						>
							<Icon icon="solar:cart-3-bold-duotone" className="nav-icon" />
							<div className="nav-text">Counter</div>
						</Link>
					</div>
					<div className="nav-item">
						<Link
							to="/pos/kitchen-order"
							className="nav-link"
							data-bs-toggle="tooltip"
							data-bs-placement="bottom"
							data-bs-title="Kitchen Order"
						>
							<Icon icon="solar:documents-minimalistic-bold-duotone" className="nav-icon" />
							<div className="nav-text">Kitchen</div>
						</Link>
					</div>
					<div className="nav-item">
						<Link
							to="/pos/table-booking"
							className="nav-link"
							data-bs-toggle="tooltip"
							data-bs-placement="bottom"
							data-bs-title="Table Booking"
						>
							<Icon icon="solar:calendar-bold-duotone" className="nav-icon" />
							<div className="nav-text">Table</div>
						</Link>
					</div>
					<div className="nav-item">
						<Link
							to="/pos/menu-stock"
							className="nav-link"
							data-bs-toggle="tooltip"
							data-bs-placement="bottom"
							data-bs-title="Menu Stock"
						>
							<Icon icon="solar:box-bold-duotone" className="nav-icon" />
							<div className="nav-text">Stock</div>
						</Link>
					</div>
				</div>
			</div>
			<div className="pos-content">
				<div className="pos-content-container p-4 pt-3">
					<div className="d-md-flex align-items-center mb-3">
						<div className="pos-booking-title flex-1">
							<div className="fs-4">Available Table (13/20)</div>
							<div className="mb-2 mb-md-0 d-flex small fw-semibold gap-3">
								<div className="d-flex align-items-center gap-1">
									<i className="fa fa-circle fa-fw text-gray-500 fs-7px"></i> Reserved
								</div>
								<div className="d-flex align-items-center gap-1">
									<i className="fa fa-circle fa-fw text-warning fs-7px"></i> Table In-use
								</div>
								<div className="d-flex align-items-center gap-1">
									<i className="fa fa-circle fa-fw text-theme fs-7px"></i> Table Available
								</div>
							</div>
						</div>
					</div>
					<div className="pos-table-row">
						{tableData && tableData.length > 0 ? (
							tableData.map((table, index) => (
								<div key={index} className="pos-table-col">
									<a
										href="#/"
										onClick={(event) => toggleMobileSidebar(event, table)}
										className={
											'pos-table' +
											(selectedTable && table.tableNo === selectedTable.tableNo
												? ' selected'
												: '') +
											(!table.orders && table.status !== 'Reserved' ? ' available' : '') +
											(table.orders ? ' in-use' : '') +
											(table.status === 'Reserved' ? ' disabled' : '')
										}
									>
										<div className="pos-table-status"></div>
										<div className="pos-table-name">
											<div className="name">Table</div>
											<div className="no">{table.tableNo}</div>
											<div className="order">
												{table.orders && <span>{table.orders.length} orders</span>}
												{table.status === 'Reserved' && (
													<span>Reserved for {table.reserveName}</span>
												)}
												{!table.orders && table.status !== 'Reserved' && (
													<span>max {table.totalPax} pax</span>
												)}
											</div>
										</div>
										<div className="pos-table-info-row">
											<div className="pos-table-info-col">
												<div className="pos-table-info-container">
													<span className="icon opacity-50">
														<i className="far fa-user"></i>
													</span>
													<span className="text">
														{table.pax} / {table.totalPax}
													</span>
												</div>
											</div>
											<div className="pos-table-info-col">
												<div className="pos-table-info-container">
													<span className="icon opacity-50">
														<i className="far fa-clock"></i>
													</span>
													<span className="text">
														{table.totalTime ? table.totalTime : '-'}
													</span>
												</div>
											</div>
										</div>
										<div className="pos-table-info-row">
											<div className="pos-table-info-col">
												<div className="pos-table-info-container">
													<span className="icon opacity-50">
														<i className="fa fa-receipt"></i>
													</span>
													<span className="text">${getTotalPrice(table.orders)}</span>
												</div>
											</div>
											<div className="pos-table-info-col">
												<div className="pos-table-info-container">
													<span className="icon opacity-50">
														<i className="far fa-dollar-sign"></i>
													</span>
													<span
														className={
															'text' + (table.status === 'Paid' ? ' text-success' : '')
														}
													>
														{table.status !== 'Reserved' ? table.status : '-'}
													</span>
												</div>
											</div>
										</div>
									</a>
								</div>
							))
						) : (
							<div className="col-12">No records found</div>
						)}
					</div>
				</div>
			</div>
			<div className="pos-sidebar" id="pos-sidebar">
				<div className="pos-sidebar-header">
					<div className="back-btn">
						<button type="button" onClick={dismissMobileSidebar} className="btn">
							<i className="fa fa-chevron-left"></i>
						</button>
					</div>
					<div className="icon">
						<i className="fa fa-plate-wheat"></i>
					</div>
					<div className="title">
						Table {selectedTable && selectedTable.tableNo ? selectedTable.tableNo : '-'}
					</div>
					<div className="order">
						Order: <b>#{selectedTable && selectedTable.orderNo ? selectedTable.orderNo : '-'}</b>
					</div>
				</div>
				<PerfectScrollbar className="pos-sidebar-body">
					<div className="pos-sidebar-list">
						{selectedTable && selectedTable.orders ? (
							selectedTable.orders.map((order, index) => (
								<div className="pos-sidebar-list-item" key={index}>
									<div className="pos-product-thumb">
										<div
											className="img"
											style={{ backgroundImage: 'url(' + order.image + ')' }}
										></div>
										<div className="info">
											<div className="title">{order.title}</div>
											<div className="desc">
												{order.options &&
													order.options.map((option, index) => (
														<div key={index}>- size: {option}</div>
													))}
											</div>
										</div>
									</div>
									<div className="pos-total-qty">x{order.quantity}</div>
									<div className="pos-total-price">
										${(parseFloat(order.price) * order.quantity).toFixed(2)}
									</div>
								</div>
							))
						) : (
							<div className="pos-order py-3">No records found</div>
						)}
					</div>
				</PerfectScrollbar>
				<div className="pos-sidebar-footer">
					<div className="d-flex align-items-center mb-2">
						<div>Subtotal</div>
						<div className="flex-1 text-end h6 mb-0">${getPrice('subtotal')}</div>
					</div>
					<div className="d-flex align-items-center">
						<div>Taxes (6%)</div>
						<div className="flex-1 text-end h6 mb-0">${getPrice('taxes')}</div>
					</div>
					<hr className="opacity-1 my-10px" />
					<div className="d-flex align-items-center mb-2">
						<div>Total</div>
						<div className="flex-1 text-end h4 mb-0">${getPrice('total')}</div>
					</div>
					<div className="d-flex align-items-center mt-3">
						<a href="#/" className="btn btn-default w-80px rounded-3 text-center me-10px">
							<i className="fab fa-paypal d-block fs-18px my-1"></i>
							E-Wallet
						</a>
						<a href="#/" className="btn btn-default w-80px rounded-3 text-center me-10px">
							<i className="fab fa-cc-visa d-block fs-18px my-1"></i>
							CC
						</a>
						<a href="#/" className="btn btn-theme rounded-3 text-center flex-1">
							<i className="fa fa-wallet d-block fs-18px my-1"></i>
							Pay by Cash
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}

export default PosCounterCheckout;
